import component from './component'

export default {
    path: '/monitoria',
    name: 'monitoria',
    component: component
}



// WEBPACK FOOTER //
// ./src/components/monitoria/transaccion/index.js